import { Button, Editor } from '@wot/components';
import { ILegal } from '@wot/typings';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import legalApi from '../../../api/legal';
import { MainBody } from '../../../components/MainBody';

export function AddTerms() {
  const { state } = useLocation();
  const [document, setDocument] = useState<ILegal>(
    state && state.doc
      ? state.doc
      :
      {
        _id: '',
        type: 'terms-conditions',
        mdText: '',
        status: 'active',
        createdAt: new Date().toISOString()
      }
  );

  const navigate = useNavigate();

  const onSave = async () => {
    if (document) {
      if (document._id) {
        legalApi.updateDocument({ _id: document._id, status: 'inactive' }).catch((err) => err);
      }
      legalApi
        .addDocument({
          type: document.type,
          mdText: document.mdText
        })
        .then((data) => {
          if (data) {
            setDocument(data);
            navigate(-1);
            toast.success('Terms and Conditions Updated Successfully!');
          }
        })
        .catch((err) => err);
    }
  };
  return (
    <MainBody>
      <div className="relative w-full min-h-screen flex flex-col gap-6 p-4 px-6 bg-white">
        <div className="flex flex-col">
          <h1 className="text-xl font-semibold mb-2">Terms & Conditions</h1>
          <p className="text-xs">Type text in the box below</p>
        </div>
        <div className="w-full h-full flex flex-col gap-5 bg-neutralBlue2 p-5 rounded-md">
          <div className="w-full flex items-center justify-between">
            <h1 className="text-base font-semibold">{dayjs(document.createdAt).format('DD/MM/YYYY')}</h1>
            <Button
              text='Save'
              onClick={() => onSave()}
            />
          </div>
          <div className="w-full h-fit">
            <Editor
              editorState={document.mdText}
              onChange={(value) => setDocument({ ...document, mdText: value || '' })}
              readOnly={false}
            />
          </div>
        </div>
      </div>
    </MainBody>
  );
}
